var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 464.056 464.056",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffdfba",
    d: "M386.028 416.796v39.26c0 4.42-3.58 8-8 8h-292c-4.42 0-8-3.58-8-8v-39.26c0-41.19 33.39-74.56 74.59-74.57 14.56-.01 27.38-7.5 34.76-18.86 7.414-11.394 6.65-21.302 6.65-29.31l.15-.37c-35.9-14.86-61.15-50.23-61.15-91.5v-3.13c-14.255 0-25-11.265-25-24.54v-41.56c-.32-14.47.34-65.5 37.2-101.03 42.86-41.31 110.78-37.93 159.98-15.83 1.6.72 1.55 3.01-.07 3.68l-12.83 5.28c-1.92.79-1.51 3.62.55 3.84l6.23.67c29.83 3.19 57.54 19.39 74.72 46.35.46.73.33 1.84-.26 2.47a60.503 60.503 0 0 0-16.52 41.56v54.57c0 13.55-10.99 24.54-24.54 24.54h-1.46v3.13c0 41.27-25.25 76.64-61.15 91.5l.15.37c0 7.777-.827 17.82 6.65 29.31 7.38 11.36 20.2 18.85 34.76 18.86 41.2.01 74.59 33.38 74.59 74.57z",
    opacity: 1,
    "data-original": "#ffdfba"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c0000",
    d: "M386.028 416.796v39.26a8 8 0 0 1-8 8h-292a8 8 0 0 1-8-8v-39.26c0-41.19 33.395-74.555 74.585-74.57 14.564-.005 27.387-7.504 34.765-18.86 25.754 22.002 63.531 22.015 89.3 0 7.377 11.356 20.201 18.855 34.765 18.86 41.19.015 74.585 33.38 74.585 74.57z",
    opacity: 1,
    "data-original": "#fe4f60",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42434d",
    d: "M373.804 75.921c.464.729.334 1.833-.259 2.461a60.537 60.537 0 0 0-16.517 41.564v54.57c0 12.388-9.333 24.54-26 24.54v-61.77c0-26.51-21.49-48-48-48h-102c-26.51 0-48 21.49-48 48v61.77c-14.255 0-25-11.265-25-24.54v-41.56c-.32-14.47.34-65.5 37.2-101.03C188.085-9.385 256.012-6.003 305.204 16.099c1.6.719 1.558 3.01-.065 3.678l-12.831 5.282c-1.918.79-1.514 3.617.548 3.838l6.232.669c29.835 3.187 57.538 19.387 74.716 46.355z",
    opacity: 1,
    "data-original": "#42434d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffebd2",
    d: "M331.028 202.186c0 54.696-44.348 99-99 99-51.492 0-99-40.031-99-102.13v-61.77c0-26.51 21.49-48 48-48h102c26.51 0 48 21.49 48 48z",
    opacity: 1,
    "data-original": "#ffebd2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M313.028 447.056h-24a8 8 0 0 1 0-16h24a8 8 0 0 1 0 16z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff3e4",
    d: "M209.612 266.114c16.277 10.183 3.442 35.156-14.376 28.004-36.634-14.704-62.208-50.404-62.208-91.932v-64.9a47.79 47.79 0 0 1 8.422-27.168c6.514-9.473 21.578-5.288 21.578 7.168v64.9c0 36.51 19.192 66.79 46.584 83.928z",
    opacity: 1,
    "data-original": "#fff3e4",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd6a6",
    d: "M271.158 310.476c-24.637 10.313-51.712 11.113-78.26 0 1.356-5.626 1.13-9.27 1.13-16.42l.15-.37c24.082 9.996 51.571 10.016 75.7 0l.15.37c0 7.153-.226 10.796 1.13 16.42z",
    opacity: 1,
    "data-original": "#ffd6a6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c0000",
    d: "M192.91 366.383c-3.698 1.163-7.664 1.804-11.916 1.841-41.296.364-74.966 33.017-74.966 74.315v7.517c0 7.732-6.268 14-14 14h-6a8 8 0 0 1-8-8v-39.26c0-41.191 33.395-74.555 74.585-74.57 14.564-.005 27.387-7.504 34.765-18.86a69.21 69.21 0 0 0 9.512 6.822c14.753 8.791 12.402 31.044-3.98 36.195z",
    opacity: 1,
    "data-original": "#ff6d7a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c0000",
    d: "M271.146 366.383c3.698 1.163 7.664 1.804 11.916 1.841 41.296.364 74.966 33.017 74.966 74.315v7.517c0 7.732 6.268 14 14 14h6a8 8 0 0 0 8-8v-39.26c0-41.191-33.395-74.555-74.585-74.57-14.564-.005-27.387-7.504-34.765-18.86a69.21 69.21 0 0 1-9.512 6.822c-14.752 8.791-12.402 31.044 3.98 36.195z",
    opacity: 1,
    "data-original": "#e84857",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d4e59",
    d: "M305.138 19.776c-11.758 4.839-13.434 5.906-17.508 5.274-65.674-10.18-123.294 16.993-142.862 80.786v.01a47.761 47.761 0 0 0-11.74 31.44v37.523c0 16.188-25 17.315-25-.293v-41.56c-.32-14.47.34-65.5 37.2-101.03 42.86-41.31 110.78-37.93 159.98-15.83 1.6.72 1.55 3.01-.07 3.68z",
    opacity: 1,
    "data-original": "#4d4e59",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.a94d2aaed4c4c88890dd22ffb6cd29d9.svg";
export { ForwardRef as ReactComponent };